import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ff11a9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-container" }
const _hoisted_2 = { class: "app__title mt-0" }
const _hoisted_3 = { class: "participant-info" }
const _hoisted_4 = {
  key: 0,
  class: "black__base__color"
}
const _hoisted_5 = {
  key: 1,
  class: "gray__base__color"
}
const _hoisted_6 = { class: "primary__color coupon__title" }
const _hoisted_7 = { class: "gray__base__color" }
const _hoisted_8 = { class: "d-flex mb-2" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "subtotal primary__dark__color" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-finished" }, null, -1))
const _hoisted_13 = { class: "text--center" }
const _hoisted_14 = {
  key: 0,
  class: "text-center"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = {
  key: 0,
  class: "title-dialog-payment mt-1"
}
const _hoisted_17 = { class: "title-dialog-payment" }
const _hoisted_18 = { class: "gray__base__color" }
const _hoisted_19 = { class: "text--center mt-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_app_card_payment_modal = _resolveComponent("app-card-payment-modal")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, { gutter: "20" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          "el-col": "",
          xs: 24,
          sm: 24,
          md: 24,
          lg: 24,
          xl: 24,
          class: "app__header__title"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("register.register")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: 24,
          lg: 24,
          xl: 24
        }, {
          default: _withCtx(() => [
            _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t("register.payment.yourTicket")), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, {
      type: "flex",
      align: "middle",
      justify: "center"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 20 }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_select, {
                class: "ticketType__select",
                modelValue: _ctx.ticketType,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ticketType) = $event)),
                "value-key": "ticketType",
                placeholder: "Select"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventData.ticketTypes, (ticketType) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: ticketType.id,
                      label: ticketType.name,
                      value: ticketType.id,
                      onClick: ($event: any) => (_ctx.selectTicket(ticketType.id))
                    }, null, 8, ["label", "value", "onClick"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_3, [
                (_ctx.participantData && _ctx.participantData.firstName)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.participantData.fullName
                  ? _ctx.participantData.fullName
                  : _ctx.participantData.firstName), 1))
                  : _createCommentVNode("", true),
                (_ctx.participantData && _ctx.participantData.email)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.participantData.email), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("coupon.couponTitle")), 1),
                _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("coupon.coupon")), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_el_input, {
                  size: "large",
                  "data-test": "coupon",
                  label: _ctx.$t('coupon.input'),
                  modelValue: _ctx.couponInput,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.couponInput) = $event))
                }, null, 8, ["label", "modelValue"]),
                _createVNode(_component_el_button, {
                  class: "ml-2 primary__color__button",
                  onClick: _ctx.applyCoupon
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("coupon.apply")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              (_ctx.shoppingCart && _ctx.shoppingCart.items)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shoppingCart.subtotals, (subtotal) => {
                      return (_openBlock(), _createElementBlock("div", { key: subtotal }, [
                        _createVNode(_component_el_row, { gutter: 20 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 24 }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_10, " $ " + _toDisplayString(_ctx.formatCurrency(subtotal)) + " " + _toDisplayString(subtotal.currency.toUpperCase()), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024),
                        _hoisted_11,
                        _createVNode(_component_el_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 24 }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shoppingCart.items, (cartItem) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: cartItem,
                                    class: "description gray__base__color"
                                  }, [
                                    _hoisted_12,
                                    _createTextVNode(" " + _toDisplayString(cartItem.product.description), 1)
                                  ]))
                                }), 128))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 24 }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_13, [
                                  _createVNode(_component_el_button, {
                                    class: "secondary__color__button",
                                    type: "primary",
                                    disabled: !_ctx.isQuotaAvailable,
                                    onClick: ($event: any) => (_ctx.preparePaymentForm(subtotal.checkout))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("register.payment.pay")), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["disabled", "onClick"]),
                                  (!_ctx.isQuotaAvailable)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                        _hoisted_15,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("register.ticketsNotAvailable")), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_el_divider)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.stripeDialogVisible,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.stripeDialogVisible) = $event)),
      center: "",
      width: _ctx.filterSize()
    }, {
      header: _withCtx(() => [
        (!_ctx.ticketPriceIsZero)
          ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.$t("register.payment.paymentDialogTitle")), 1))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        (!_ctx.ticketPriceIsZero)
          ? (_openBlock(), _createBlock(_component_app_card_payment_modal, {
              key: 0,
              stripeClientSecret: _ctx.stripeClientSecret,
              stripeAccountId: _ctx.stripeAccountId,
              couponId: _ctx.couponInput,
              couponApply: _ctx.validCoupong,
              isQuotaAvailable: _ctx.isQuotaAvailable,
              subtotal: _ctx.revenueTicket
            }, null, 8, ["stripeClientSecret", "stripeAccountId", "couponId", "couponApply", "isQuotaAvailable", "subtotal"]))
          : (_openBlock(), _createBlock(_component_el_row, {
              key: 1,
              type: "flex",
              justify: "center",
              align: "center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  xs: 24,
                  sm: 24,
                  md: 24,
                  lg: 24,
                  xl: 24,
                  class: "text--center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t("register.payment.registerTitle")), 1),
                    _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t("register.payment.registerMessage")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  xs: 24,
                  sm: 24,
                  md: 24,
                  lg: 24,
                  xl: 24,
                  class: "text--center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_el_button, {
                        block: "",
                        class: "secondary__color__button",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updatePaymentStatusWhenPriceIsZero()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("register.payment.register")), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
      ]),
      _: 1
    }, 8, ["modelValue", "width"])
  ]))
}